export const defaultStyle = {
paginationWrap:"justify-center flex items-center",
pagination: "paginationlist flex !list-none !items-center mb-[30px] md:mb-[50px]",
paginationItem: "!list-none",
paginationbt: "bg-transparent border-none text-grey40 max-w-[35px] w-[35px] h-[35px] max-h-[35px] min-h-[35px] p-[0] m-[0] text-[18px] rounded-[50%]",
pageLink:"bg-transparent border-none text-purple px-[25px] py-[0] m-[0] text-[18px] !w-[auto] font-bold"
}

export const NEWS_SEARCH_PAGINATION = {
  paginationWrap: "mx-auto w-[75%] pl-[10px]",
  paginationItem:"!list-none mr-[15px] text-center",
  pagination: "paginationNews flex !list-none !items-center pb-[40px] ",
  paginationbt:"text-[12px] hover:bg-black hover:text-white",
  paginationPrevItem:'paginationPrevItem mr-[15px] ',
  paginationNextItem:'paginationNextItem',
  pageLink:"pageLink text-[12px] hover:bg-black hover:text-white leading-normal lowercase",
}
